import React from 'react';

import {
  SidebarListItemContainer,
  SidebarListItemIcon,
  SidebarListItemText,
} from 'src/components/sidebar/sidebar-items/SidebarListItem';
import { RouteContext, useFeatureFlags } from 'src/context';
import useNavigate from 'src/hooks/useNavigate';
import { useAppSelector } from 'src/hooks/useStore';
import { useRouteAccess } from 'src/routes/routeAccess';

const BUILD_TAB_PATH = '/app-setup/build?tab=build';
const DEFAULT_TAB_PATH = '/app-setup/build?tab=apps';

export const AddAppSidebarItem = () => {
  const { navigate } = useNavigate();
  const isClient = useAppSelector((state) => state.user.isClient);
  const { EnableAppBuilder, EnableAppSetupImprovements } = useFeatureFlags();
  const { routeAccess } = useRouteAccess();
  const { pathname } = React.useContext(RouteContext);

  const canAccess =
    !isClient &&
    (EnableAppSetupImprovements || EnableAppBuilder) &&
    routeAccess.allowSettingsModuleManagement;

  if (!canAccess) return null;

  // Don't highlight when inside a specific builder session — that route owns
  // the corresponding draft sidebar item, which surfaces its own active state.
  const isOnAppSetupRoute =
    pathname.includes('/app-setup/build') &&
    !pathname.includes('/app-setup/build/session/');

  const targetPath = EnableAppBuilder ? BUILD_TAB_PATH : DEFAULT_TAB_PATH;

  return (
    <SidebarListItemContainer
      htmlId="sidebar-add-app"
      handleClick={() => navigate(targetPath)}
      selected={isOnAppSetupRoute}
    >
      <div className="flex items-center opacity-60">
        <SidebarListItemIcon className="min-w-6" iconName="Plus" />
        <SidebarListItemText text="Add App" />
      </div>
    </SidebarListItemContainer>
  );
};
